<script setup lang="ts">
import type { IToolbarButtonProps, IToolbarProps } from "../types";
import { ShopSelectToolbarButtons } from "../enums";
import ShopSelectToolbarButton from "./ShopSelectToolbarButton.vue";

withDefaults(defineProps<IToolbarProps>(), {
  buttons: () => [],
});
const emit = defineEmits<{
  "click:button": [type: ShopSelectToolbarButtons];
}>();
const handleButtonClick = (button: IToolbarButtonProps) => {
  if (button.disabled) return;
  emit("click:button", button.type);
};
</script>

<template>
  <section class="shop-select__toolbar__outer">
    <div class="shop-select__toolbar" data-test-id="map-toolbar">
      <ShopSelectToolbarButton
        v-for="button in buttons"
        :key="button.type"
        :disabled="button.disabled"
        :type="button.type"
        @click="handleButtonClick(button)"
      />
    </div>
  </section>
</template>

<style lang="postcss" scoped>
.shop-select__toolbar {
  position: relative;
  bottom: 26px;

  @media (--pl-viewport-from-ml) {
    position: static;
  }

  &__outer {
    position: absolute;
    width: 100%;
    height: 0;
    right: 16px;
    overflow: visible;
    display: flex;
    flex-direction: column;
    z-index: 20;
    align-items: flex-end;
    top: 92px;

    @media (--pl-viewport-from-ml) {
      right: var(--pl-unit-x8);
      justify-content: center;
      top: 50%;
    }
  }
}
</style>
